import React from 'react'
import { OnlyWithPresetsOrId } from './eventPackage/package/common'
import { APIBaseProductPackage } from 'services/api/entities/catalog/packages/common'
import { ProductPresetField } from './ProductPresetField'
import { Container, Box } from '@mui/material'

type Props = {
  pkg?: OnlyWithPresetsOrId<APIBaseProductPackage>
}

const BaseProductPresetReadonlyList: React.FC<Props> = ({ pkg }) => {
  return (
    <Container>
      <Box display="flex" flexDirection="column">
        {pkg &&
          typeof pkg !== 'number' &&
          pkg.presets.map((preset, index) => (
            <React.Fragment key={preset.id}>
              <h3>{`${index + 1}) \n`}Presets</h3>
              <ProductPresetField record={preset} hasRatioMultiplier />
            </React.Fragment>
          ))}
      </Box>
    </Container>
  )
}

export default BaseProductPresetReadonlyList
